/* eslint-disable i18next/no-literal-string */

import { AndroidTVAppLink, AppleTVAppLink } from './links';

import * as styles from './Cards.module.scss';

export const donglesContent = {
  title: 'Se VGTV med tilleggsutstyr',
  tabs: [
    {
      label: 'TV-boks',
      content: (
        <>
          <div>
            Mange nyere TV-bokser har støtte for Google play-butikken.
            Eksempelvis Get, Telia, Altibox og Allente. For disse boksene vil du
            kunne laste ned VGTV-appen via Google Play-butikken.
          </div>
          <div>
            Søk på VGTV i Google play-butikken og last ned appen til din TV. Du
            må være innlogget på samme Google-bruker som på din TV, for å kunne
            laste ned appen fra nettleser.
          </div>
          <div className={styles.appIcons}>
            <AndroidTVAppLink />
          </div>
        </>
      ),
    },
    {
      label: 'Apple TV',
      content: (
        <>
          <div>VGTV har støtte for Apple TV via VG-appen. </div>
          <div>
            Gå til Appstore på din Apple TV-enhet, søk opp VG og last ned
            VG-appen.
          </div>
          <div className={styles.appIcons}>
            <AppleTVAppLink />
          </div>
        </>
      ),
    },
    {
      label: 'Google TV',
      content: (
        <>
          <div>Vi har støtte for Google TV.</div>
          <div>
            Gå til Google Play-butikken i nettleser eller på direkte på din
            enhet, og søk opp VGTV-appen.
          </div>
          <div>
            Du kan laste ned TV-appen direkte til din TV fra nettleser. OBS! Du
            må være innlogget samme Google-bruker som på TV-en din, for å få
            lastet ned appen fra nettleser.
          </div>
          <div className={styles.appIcons}>
            <AndroidTVAppLink />
          </div>
        </>
      ),
    },
  ],
};
